import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import './idealCareer.module.scss';
import { BackButtonHeader } from './BackButtonHeader';
import { V3Routes } from '../../../routes';
import { observable } from 'mobx';
import { IdealCareerPaneState } from './states/IdealCareerPaneState';
import { GlobalLoader } from '../../../../mainv2/components/GlobalLoader';
import { ImageUploadPane } from './ImageUploadPane';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

type Props = {
    homeState: HomePageState;
};

@inject('homeState')
@observer
export class IdealCareerPane extends React.Component<Props> {
    @observable pageState = new IdealCareerPaneState();

    componentDidMount(): void {
        this.pageState.init();
    }

    render() {
        const { idealCareer } = this.pageState;
        if (idealCareer.loading) {
            return <GlobalLoader />;
        }
        const career = idealCareer.getOrThrow();
        return (
            <div styleName="pane">
                {GlobalStatesV3.viewport.isNonSp && <BackButtonHeader to={V3Routes.goals()} />}
                <div styleName="h1">理想のキャリア</div>
                <div styleName="section">
                    <ImageUploadPane
                        type={GlobalStatesV3.viewport.isSp ? 'sp' : 'desktop'}
                        url={career.url}
                        onSelectFiles={this.pageState.setIdealCareer}
                    />
                </div>
            </div>
        );
    }
}
